import React from 'react';

import EventCalender from './EventCalender';
import TotalSummary from './TotalSummary';
import { Box, Heading, Flex } from '@chakra-ui/core';

const Summary = ({
  menuOpen,
  history: { totalAcreage = 0, totalExpenses = 0, totalYield = 0 }
}) => {
  return (
    <Box bg="cf.100" px={{ base: 16, md: 20, lg: 48 }} py={20}>
      <Box mx="auto" className="container">
        <Flex wrap="wrap" align="center">
          <Box w={{ base: '100%', md: '50%' }} mb={{ base: 8, md: 0 }}>
            <Heading as="h4">Total Summary</Heading>

            <Box>
              <TotalSummary
                totalAcreage={totalAcreage}
                totalExpenses={totalExpenses}
                totalYield={totalYield}
              />
            </Box>
          </Box>
          {/* <div className="w-full md:w-1/2 md:pl-4 lg:pl-0">
            <h3 className="text-xl font-bold">Next Event</h3>
            <EventCalender />
          </div> */}
        </Flex>
      </Box>
    </Box>
  );
};

export default Summary;
